export const removeHtmlTagsAndEntities = (input: string) => {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.body.textContent || "";
  }

export const removeHtmlTagsAndEntitiesWithSpacesOnBlockElements = (input?: string | null) => {
    if (!input) return "";
    const withSpaces = input.replace(/<\/(p|li|ul|ol)>/gi, " ").replace(/<(p|li|ul|ol)[^>]*>/gi, "");
    return removeHtmlTagsAndEntities(withSpaces);
};

export const extractPlainTextPreview = (htmlContent: string, maxSourceLength = 400, previewLength = 100) => {
    const fullPlainText = removeHtmlTagsAndEntities(htmlContent?.substring(0, maxSourceLength) ?? "");
    const preview = fullPlainText.length > previewLength ? `${fullPlainText.substring(0, previewLength)}...` : fullPlainText;
    return { fullPlainText, preview };
};
  